<ng-container>
    <div>
        <mat-card appearance="outlined">
            <mat-card-title>New Release Features</mat-card-title>

            <div class="container-fluid">
                <div [innerHTML]="this.NewReleaseFeaturesHtml"></div>
            </div>
        </mat-card>

        <!--
        <mat-card>
            <mat-card-title>Coming Soon Release Features</mat-card-title>

            <div class="container-fluid">
                <div [innerHTML]="this.ComingSoonReleaseFeaturesHtml"></div>
            </div>
        </mat-card>
        -->
    </div>
</ng-container>
